/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-18 13:43:08
 */
export default {
  lang: "英语",
  landing: {
    name1: "Buka Carlcare",
    name2: "Buat reservasi",
    name3: "Dengan Carlcare, Anda dapat memeriksa pesanan Anda kapan saja.",
    name4: "Kode Verifikasi",
    name5: "Geser ke kanan",
    name6: "Verifikasi berhasil",
    // name7: "Flat Price Battery Replacement (“From Rp120K”)",  // 活动标题 主标题
    name8: "Garansi 3 bulan untuk baterai yang diganti", // 活动标题 副标题
    name9: "Apa itu Penggantian Baterai dengan Harga Tetap ?", // 标题
    name10: "Layanan penggantian baterai dengan harga tetap ini dikhususkan untuk model Infinix/Tecno/itel yang tidak bergaransi.",
    name11: "Mulai dari harga Rp.120.000, Anda bisa mendapatkan penggantian baterai tanpa biaya jasa.",
    name12: 'Klik link untuk membuat reservasi atau kunjungi service center yang ditunjuk untuk menikmati layanan ini.', // 小字标注
    name13: "Mengapa Memilih Penggantian Baterai Harga Tetap Carlcare ?",
    name14: "Asli dan Terpercaya",
    name15: "Suku cadang resmi 100% sangat cocok dengan perangkat Anda.",
    name16: "Harga lebih rendah dan transparan",
    name17: "Nikmati harga diskon tetap untuk baterai tanpa biaya jasa.",
    name18: "Garansi 3 bulan",
    name19: "Nikmati penggunaan bebas khawatir dengan garansi yang dapat diandalkan.",
    name20: "Layanan di Tempat yang Cepat dan Mudah",
    name21: "Penggantian baterai yang cepat dan nyaman dilakukan secara langsung.",
    name22: "Perbaikan Bebas Khawatir",
    name23: "Perbaikan profesional dengan kualitas terjamin dan tahan lama.",
    // name24: "1. Periode: 9 Juni 2025 - 9 Agustus 2025",
    name25: "1. Baterai yang diganti dalam promosi ini dilengkapi dengan garansi resmi selama 3 bulan.",
    name26: "2. Promosi ini hanya berlaku untuk penggantian baterai di luar garansi.",
    name27: "3. Jika Anda mengikuti promosi baterai harga tetap, Anda harus setuju untuk mendaur ulang baterai asli yang diganti di pusat layanan.",
    name28: "4. Promosi ini tidak dapat digabungkan dengan penawaran lainnya. Stok terbatas, selama persediaan masih ada.",
    name29: "5. Saat ini, promosi hanya berlaku di service center tertentu. Untuk keterangan lebih rinci, silakan merujuk ke lokasi layanan tertentu.",
    name30: "6. Carlcare berhak mengubah promosi berdasarkan situasi aktual. Untuk pertanyaan atau bantuan, silakan hubungi hotline Carlcare di 021 5088 0282.",
    name31: "Peraturan",
    name32: "Baterai Original",
    name33: "Awet & Terjamin",
    name34: "Mulai dari 120rb",
    name35: "Daftar Harga Baterai",
    name36: "Brand",
    name37: "Seri",
    name38: "Model",
    name39: "Harga",
    name40: "Eksklusif untuk",
    name41: "Pasig, Marikina, and Quezon City!",
    name42: "Reservasi Sekarang",
    name43: "Apa itu layanan Home Service dari Carlcare ?",
    name44: "1.Layanan home service tersedia untuk pengguna Infinix, tecno dan Itel.",
    name45: "2.Nikmatin layanan perbaikan yang nyaman efisien dimana saja (Rumah, Kantor, Cafe, Kampus, atau di outdoor) hemat waktu dan tenaga.",
    name46: "Mengapa kami merekomendasikan layanan Home Service dari Carlcare ?",
    name47: "Gratis biaya layanan Home Service",
    name48: "Tidak dipungut biaya Home Service.",
    name49: "*Biaya perbaikan untuk unit diluar masa garansi atau kerusakan karena kelalaian.",
    name50: "Pemesanan mudah",
    name51: "Pemesanan mudah melalui aplikasi Carlcare, website, hotline atau WhatsApp.",
    name52: "Aman dan dapat diandalkan",
    name53: "Kami pastikan perangkat anda berada di tangan yang tepat, perbaikan tepat dan aman sesuai dengan ketentuan yang berlaku.",
    name54: "Layanan resmi",
    name55: "Semua perbaikan yang dilakukan oleh teknisi resmi Carlcare menggunakan sparepart asli.",
    name56: "Cara-cara untuk memesan layanan Home Service dari Carlcare",
    name57: "1. Buka Aplikasi Carlcare",
    name58: '2. Ketuk "Reservasi"',
    name59: '3. Pilih layanan perbaikan "Carlcare Home Service"',
    name60: "4. Pilih lokasi Anda saat ini",
    name61: "5. Isi detail yang diperlukan untuk menyelesaikan reservasi",
    name62: "1. Buka Situs Resmi Carlcare:https://www.carlcare.com/id/",
    name63: '2. Ketuk "Perbaiki Telepon"',
    name64: '3. Pilih layanan perbaikan "Carlcare Home Service"',
    name65: "4. Pilih lokasi Anda saat ini",
    name66: "5. Isi detail yang diperlukan untuk menyelesaikan reservasi",
    name67: "Hubungi hotline Carlcare:021 5088 0282 untuk memesan layanan Home Service dari Carlcare.",
    name68: "Hubungi WhatsApp Business Carlcare:+62-812-9009-0559 untuk memesan layanan Home Service Carlcare.",
    name69: "1.Perangkat butuh perbaikan.",
    name70: "2.Pesan layanan Home Service dari Carlcare.",
    name71: "3.Teknisi akan menghubungi Anda untuk mengkonfirmasi waktu janji temu.",
    name72: "4.Teknisi tiba pada waktu yang dijadwalkan.",
    name73: "5.Perbaikan selesai dan lakukan pembayaran.",
    name74: "Pernyataan:",
    name75: "1.Layanan Home Service gratis hanya berlaku untuk biaya layanan.",
    name76: "①Dalam masa garansi:Nikmati gratis biaya layanan Home Service dan perbaikan;",
    name77: "②Diluar masa garansi:Hanya membayar biaya jasa dan separepart, tidak dikenakan biaya layanan Home Service.",
    name78: "2.Layanan Carlcare Home Service saat ini terbatas di wilayah Jakarta dan akan diperluas secara bertahap ke lebih banyak daerah di waktu yang akan datang.Pantau terus informasinya!",
    name79: "3.Penjelasan akhir mengenai aktivitas ini sepenuhnya menjadi hak Carlcare.",
    name80: "App",
    name81: "Website",
    name82: "Hotline",
    name83: "WhatsApp",
    name84: "Tidak ada biaya kunjungan",
    name85: "Proses Layanan:",
    name86: "Pesan layanan",
    name87: "Home Service",
    name88: " hari ini!",
  },
  order: {
    name1: "Pilih model perangkat",
    name2: "Keterangan Kerusakan:",
    name3: "Ketuk untuk memilih toko layanan",
    name4: "Toko Layanan:",
    name5: "Waktu Pemesanan:",
    name6: "Harap jelaskan masalah perangkat Anda secara terperinci!",
    name7: "Ketuk untuk memilih waktu kedatangan",
    name8: "Masukkan perincian kontak yang benar agar kami dapat menghubungi Anda",
    name9: "Waktu reservasi yang tersedia adalah sebagai berikut",
    name10: "Masukkan nomor telepon Anda",
    name11: "Harga",
    name12: "Informasi Pribadi:",
    name13: "Silahkan masukkan nama anda",
    name14: "Kirim",
    name15: "Batal",
    name16: "Oke",
  },
  shops: {
    name1: "Berdasarkan merek yang Anda pilih, toko-toko berikut dapat melayani Anda!",
    name2: "Segera hadir di lebih banyak toko ritel! Tetaplah bersama kami!",
  },
  price: {
    name1: "Merek",
    name2: "Model",
    name3: "ITEM",
    name4: "Harga",
    name5: "Pengingat Ramah:",
    name6: "Harga ini hanya untuk referensi, dan harga sesungguhnya tergantung kondisi perangkat Anda.",
    name7: "Apabila tidak ada simbol khusus, satuan harga adalah satuan mata uang setempat.",
    name8: "Maaf! Info harga tidak tersedia di wilayah saat ini.",
    name11:"Biaya Tenaga Kerja",
    name12:"Harga Total",
    name13: "5. Jika biaya tenaga kerja \"/\", berarti biaya tenaga kerja perlu dikonsultasikan dengan toko.",
    item_main_board: "Mainboard",
    item_screen_frame: "Screen(Frame)",
    item_screen_screen_frame: "Secondary Screen(Frame)",
    item_touch_screen: "Touch Screen",
    item_camera: "Camera",
    item_fixed_focus_camera: "Fixed Focus Camera",
    item_auto_focus_camera: "Auto Focus Camera",
    item_screen: "Screen",
    item_secondary_screen: "Secondary Screen",
    item_fingerprint_module: "Fingerprint Module",
    item_speaker: "Speaker",
    item_receiver: "Receiver",
    item_small_board: "Small Board",
    item_battery_cover: "Battery Cover",
    item_battery: "Battery",
    item_charger: "Charger",
    item_usb_cable: "USB Cable",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Tidak ada data",
    name2: "Penyedia Layanan:",
    name3: "Merek Layanan:",
    name4: "Telepon:",
    name5: "Jumlah Pesanan:",
    name6: "Nilai Layanan",
    name7: "Lingkungan Layanan:",
    name8: "Sikap Layanan:",
    name9: "Efisiensi Layanan:",
    name10: "Kualitas Layanan:",
    name11: "Evaluasi Pelanggan",
    name12:"hingga",
    name13:"Tutup",
    name14:"Alamat:"
  },
  reserSuccess: {
    name1: "Ambil foto layar info reservasi dan simpan sebagai tanda terima untuk mengakses layanan prioritas.",
    name2: "Berhasil dikirimkan",
    name3: "1. Bersihkan data",
    name4: "Cadangkan data pribadi yang penting di ponsel Anda terlebih dahulu",
    name5: "2. Nonaktifkan kata sandi penyalaan",
    name6: "Sebelum pergi ke toko layanan, harap:",
    name7: "Toko Layanan:",
    name8: "Waktu Pemesanan:",
    name9: "Keterangan Kerusakan:",
    name10: "Model Perangkat:",
    name11: "Nomor Pesanan:",
    name12: "Informasi Pemesanan",
  },
  title: {
    name1: "Mendukung negara berikut:",
    name2: "Pilih Model",
    name3: "Reservasi",
    name4: "Detail Toko Layanan",
    name5: "Pilih Toko Layanan",
  },
  error: {
    name1: "Tidak ada data. Periksa info perbaikan Anda",
    name2: "Perlu bantuan lainnya? Harap hubungi kami.",
    name3: "Maaf, tidak ada pusat Carlcare di wilayah Anda saat ini.",
    name4: "Pilih pusat layanan terlebih dahulu",
    name5: "Gagal",
    name6: "Pilih model perangkat terlebih dahulu",
    name7: "Informasi Kesalahan:",
    name8: "Jelaskan kebutuhan Anda secara terperinci",
  },
  add1:{
    "name0": "id",
    "name00": "Pilih Kotamu",//Choose your city
    "name01": "Jakarta",//Jakarta 这个城市
    "name0x": "Lainnya",//others
    "name1": "Pesanan Anda telah dikonfirmasi. Kami menunggu kedatangan Anda.",
    "name2": "Pilih Kota",
    "name3": "Silahkan masukan %1$s digit nomor telepon.",
    "name4": "Jam kerja",
    "name5": "Senin",
    "name6": "selasa",
    "name7": "rabu",
    "name8": "kamis",
    "name9": "jumat",
    "name10": "sabtu",
    "name11": "Minggu",
    "name12": "Masukan Negara dan cari"
  },
  add2:{
    "name0": "Indonesian",
    "name1": "Metode Perbaikan",
    "name2": "Perbaikan di tempat",
    "name3": "Jasa Pengiriman",
    "name4": "Tipe Kerusakan",
    "name5": "Ketuk untuk memilih tipe kerusakan",
    "name6": "Waktu Pemesanan:",
    "name7": "ketuk untuk memilih waktu pemesanan",
    "name8": "Alamat penjemputan",
    "name9": "Mohon memasukan nomor rumah/ jalan/kabupaten/provinsi",
    "name10": "Mohon memasukan kode pos",
    "name11": "Tambahkan alamat pengembalian",
    "name12": "Alamat pengembalian",
    "name13": "Lain-lain",
    "name14":"Harap ceritakan masalah perangkatmu secara rinci",
    "name15":"Mengirimkan Kode Pos",
    "name16":"Harap isi nomor/jalan/kecamatan/provinsi",
    "name17":"Harap isi kode pengembalian",
    "name18":"Kode pos pengembalian",
    "name19":"Alamat pengirim",
    "name20":"Pilih Provinsi",
    "name21":"Mohon izinkan Carlcare untuk mengetahui lokasi Anda",
    "name22":"gagal mendapatkan lokasi coba lagi pls"
  },
  add3:{
    "name0": "Indonesian",
    "name1": "Kurir kami akan segera menghubungi",
    "name2": "Halaman Utama",
    "name3": "Rincian Pengiriman",
    "name4": "Salin",
    "name5": "Salin Nomer Resi",
    "name6": "Informasi Penerima",
    "name7": "Nama",
    "name8": "Nomer Telepon",
    "name9": "Alamat",
    "name10": "Masukan nomer pesanan anda/nomer telepon untuk melihat detail pengiriman",
    "name11": "Tampilkan hanya 30 hari pesanan",
    "name12": "Nomer pesanan",
    "name13": "Tanggal Buat",
    "name14": "Pengitiman di kembalikan",
    "name15": "Informasi pengiriman",
    "name16": "Kirim",
    "name17": "Mengembalikan gawai ke pelanggan",
    "name18": "kembali",
    "name19": "batal kirim",
    "name20": "batalkan pengiriman",
    "name21": "pesanan tidak dapat di batalkan ketika belum di ambil kurir",
    "name23": "Tinjauan",
    "name24": "Perangkat telah terkirim",
    "name25": "Perangkat telah dikirim",
    "name26": "Diperbaiki",
    "name27": "Dalam Perbaikan",
    "name28": "Terkirim, toko telah menerima perangkat",
    "name29": "Menunggu penjemputan",
    "name30": "Mengajukan aplikasi penjemputan",
    "name31": "nomor pengiriman:",
    "name32": "Anda membatalkan pesanan",
    "name33": "Kurir membatalkan pesanan",
    "name33_1": "admin membatalkan pesanan",
    "name34": "Rincian pengiriman",
    "name35": "tolong masukkan kode verifikasi untuk membatalkan pesanan",
    "name36": "kirim kode",
    "name37": "kirim ulang",
    "name38": "kode",
    "name39": "tidak dapat diedit",
    "name41": "Mohon Pilih alasan pembatalan",
    "name42": "Informasi salah",
    "name43": "Masukan alasan",
    "name44": "Mohon masukan alasan",
    "name45": "Mengirim",
    "name46": "Dikarenakan jarak diluar jangkauan, mohon hubungi kami via WhatsApp, tim kami akan melayani Anda",
    "name47":"Layanan antar jemput Carlcare",
    "name48":"Akun Bisnis WhatsApp",
    "name49":"Toko membatalkan Pesanan",
    "name50":"Perintah telah dibatalkan",
    "name51":"JNE Express",
    "name52":"Receiver Info",
    "name53":"Arrived",
    "name54":"On delivery",
    "name55":"Picked",
    "name56":"Go to pick-up location",
    "name57":"Order accepted",
    "name58":"Pending",
  },
  reasonlist:{
    name0:"Merubah waktu penjemputan",
    name1:"Alamat tidak sesuai",
    name2:"Khawatir dengan proses layanan, ponsel hilang dan tidak ada kompensasi ",
    name3:"Ingin datang ke Service Center",
    name4:"Alasan privasi",
    name5:"Diluar jangkauan layanan antar jemput",
    name6:"Kurir tidak datang tepat waktu",
  },
  coupons: {
    name1:"Buka Aplikasi Carlcare untuk mendapatkan kupon",
    name2:"Tekan untuk membuka",
    name3:"Buka Aplikasi Carlcare untuk memberikan penilaian",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Pilih Layanan",
    name7:"Pembersihan Gratis",
    name8:"Upgrade Perangkat Lunak",
  },
  cancelorder:{
    "cancelReason0": "Info salah",
    "cancelReason1": "Tidak tiba tepat waktu",
    "cancelReason2": "Pesanan duplikat/bukan pesanan saya",
    "cancelReason3": "Kegagalan tidak terulang",
    "cancelReason4": "Cuma untuk tes/pertanyaan/acara/…",
    "cancelReason5": "Mahal",
    "cancelReason6": "Kekurangan material",
    "cancelReason7": "Tidak ada layanan yang istimewa",
    "cancelReason8": "Toko terlalu jauh",
    "cancelReason9": "Toko tutup",
    "cancelReason10": "Sikap pelayanan buruk",
    "cancelReason11": "Penggantian/perbaikan untuk merek lainnya",
    "cancelReason12": "Tidak dapat menemukan toko",
    "cancelReason13": "lainnya",
    "cancelOrder": "Batalkan pesanan",
    "reason_dialog_title": "Beri tahu kami alasan pembatalan",
    "Cancel": "Batal",
    "OK": "Oke",
    "name1": "Masukkan kode verifikasi",
    "name2": "Kode verifikasi tidak valid",
    "repair_reservation_detail_canceled": "Pesanan ini telah Dibatalkan!",
    "purchase_cancel_dialog_content": "Apakah Anda yakin ingin membatalkan pesanan?",
    "yes": "Ya",
    "no": "Tidak"
}
};